const REM = 16;

export function listColumns(width: number, minRem: number, gapRem = 0.75): number {
    if (!Number.isFinite(width) || width <= 0) return 1;
    const min = Math.max(1, (Number.isFinite(minRem) ? minRem : 1) * REM);
    const gap = Math.max(0, (Number.isFinite(gapRem) ? gapRem : 0) * REM);
    return Math.max(1, Math.floor((width + gap) / (min + gap)));
}

export default listColumns;
